import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Affichage multi-devises. IMPORTANT : les prix sont TOUJOURS stockés et débités
// en yens (devise du guide, qui reçoit exactement son tarif). La devise choisie
// ici ne change que l'AFFICHAGE (estimation convertie).

var API_URL = process.env.REACT_APP_BACKEND_URL;
var STORAGE_KEY = 'gm_currency';

var CurrencyContext = createContext();

var SYMBOLS = { JPY: '¥', EUR: '€', USD: '$' };

// État partagé, tenu à jour par le provider. Permet à formatMoney() d'être appelée
// depuis n'importe quel module (les pages ont des dizaines d'appels d'affichage)
// sans devoir passer le contexte partout. Les composants qui affichent des prix
// appellent useCurrency() pour se re-rendre quand la devise change.
var _display = { currency: 'JPY', rates: { JPY: 1 } };

function _fmt(v, cur) {
  var sym = SYMBOLS[cur] || '';
  if (cur === 'JPY') return sym + Math.round(v).toLocaleString('fr-FR');
  return sym + v.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Formate un montant exprimé dans la devise du guide (fromCurrency) vers la
// devise d'affichage choisie par le voyageur. Le débit se fait toujours dans la
// devise du guide.
export function formatMoney(amount, fromCurrency) {
  var from = (fromCurrency || 'JPY').toUpperCase();
  var n = Number(amount) || 0;
  var cur = _display.currency;
  var rates = _display.rates || {};
  if (cur === from || !rates[cur] || !rates[from]) return _fmt(n, from);
  var inJpy = n / rates[from];          // les taux ont le yen pour base
  return '≈ ' + _fmt(inJpy * rates[cur], cur);
}

export function useCurrency() {
  var ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency must be used within CurrencyProvider');
  return ctx;
}

export function CurrencyProvider(props) {
  var savedState = useState(function() {
    try { return localStorage.getItem(STORAGE_KEY) || 'JPY'; } catch (e) { return 'JPY'; }
  });
  var currency = savedState[0];
  var setCurrencyState = savedState[1];

  var ratesState = useState({ JPY: 1 });
  var rates = ratesState[0];
  var setRates = ratesState[1];

  useEffect(function() {
    axios.get(API_URL + '/api/rates')
      .then(function(res) { if (res.data && res.data.rates) setRates(res.data.rates); })
      .catch(function() { /* on garde l'affichage en yens */ });
  }, []);

  // Tient à jour l'état partagé lu par formatMoney().
  _display.currency = currency;
  _display.rates = rates;

  function setCurrency(c) {
    setCurrencyState(c);
    _display.currency = c;
    try { localStorage.setItem(STORAGE_KEY, c); } catch (e) { /* ignore */ }
  }

  // Formate un montant exprimé dans la devise du guide (fromCurrency, par défaut
  // JPY) vers la devise d'affichage choisie par le voyageur.
  // Le débit réel se fait TOUJOURS dans la devise du guide.
  function formatPrice(amount, fromCurrency) {
    return formatMoney(amount, fromCurrency);
  }

  // Vrai si l'affichage courant peut être une estimation convertie.
  var isConverted = currency !== 'JPY';

  var value = {
    currency: currency,
    setCurrency: setCurrency,
    currencies: ['JPY', 'EUR', 'USD'],
    symbols: SYMBOLS,
    rates: rates,
    formatPrice: formatPrice,
    isConverted: isConverted
  };

  return React.createElement(CurrencyContext.Provider, { value: value }, props.children);
}
